/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LoginGuard } from './luancher/login/login.guard';
import { PagesGuard } from './pages/pages.guard';
import { SystemConfigurationGuard } from './luancher/setting/system.configuration.guard';
import { EnvironmentSpecificService } from './environment-specific.service';
import { ToastrModule } from 'ngx-toastr';
import { Http } from './pages/shared/http-client/http-client.component';
import { AngularMyDatePickerModule } from 'angular-mydatepicker';
import { CurrencyPipe } from '@angular/common';
import { SocketIoModule } from 'ngx-socket-io';
import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { NbIconModule } from '@nebular/theme';

@Injectable()
export class SocketOne extends Socket {
  constructor(
    private _envService: EnvironmentSpecificService,) {
    super({ url: _envService.envSpecific.apiUrl.replace("/api",""), options: {} });;
  }
}


@Injectable()
export class AppSocket extends Socket {
  
  constructor(
    private _envService: EnvironmentSpecificService,) {
    super({ url: _envService.envSpecific.appUrl, 
    options: {
      path:_envService.envSpecific.wsPath,
      transports: ['websocket'],  // https://stackoverflow.com/a/52180905/8987128
      upgrade: false,
      query:  { token : JSON.parse(localStorage.getItem("currentUser")).socketToken },
      reconnection: true
    } });
  }

  //"_envService.envSpecific.apiUrl.replace("/api","copssocket")"
  
}

import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 3000,
      closeButton: true,
      positionClass: 'toast-top-center',
      preventDuplicates: false,
      enableHtml: true
    }),
    AngularMyDatePickerModule,
    SocketIoModule,
    NbIconModule,
    NbDatepickerModule.forRoot(),
  ],
  bootstrap: [AppComponent],
  providers:[
    LoginGuard,
    PagesGuard,
    SystemConfigurationGuard,
    EnvironmentSpecificService,
    Http,
    CurrencyPipe,
    SocketOne,
    AppSocket
  ]
})
export class AppModule {
}
